import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "shimmer", "results"]

  connect() {
    // Controller connected - search only happens on Enter
    console.log("Story search controller connected")
  }

  // Only search on explicit Enter key press
  submitSearch(event) {
    event.preventDefault()
    const query = this.inputTarget.value.trim()
    if (query.length >= 2) {
      window.location.href = `/stories/search?q=${encodeURIComponent(query)}`
    }
  }

  // Disabled: We don't do real-time search anymore to avoid navigation issues
  // search() { }
}
